import React, { useState, useEffect, useRef } from 'react'
import { Line } from 'react-chartjs-2'
import { Chart as ChartJS } from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// utils
import { getPeriod } from '../../../utils/getPeriod'
import { getTicks } from '../../../utils/getTicks'

// styles
import colors from '../../../styles/colors'

ChartJS.register(zoomPlugin)

const TEMP_DATA = [
  {
    label: '테스트1',
    borderColor: colors.mainG,
    borderWidth: 2,
    // data: Array.from(
    //   { length: 93 },
    //   (v, i) => (v = Math.floor(Math.random() * (150 - 0) + 0)),
    // ),
    data: null,
    fill: false,
    backgroundColor: 'green',
    pointHoverRadius: 2,
    pointHoverBorderWidth: 4,
  },
]

const INIT_DATA = getPeriod(
  moment().subtract(31, 'd').format('YYYY-MM-DD'),
  moment().subtract(1, 'd').format('YYYY-MM-DD'),
)

const NewDateChart = ({ orderSearch, chartItem }) => {
  // test
  const chartRef = useRef(null)
  const [data, setData] = useState({
    labels: INIT_DATA,
    datasets: TEMP_DATA,
    // 플러그인
    plugins: [ChartDataLabels],
  })
  const [options, setOptions] = useState(null)

  // 툴팁 그림자
  const shadowPlugin = {
    id: 'shadow',
    beforeDraw: (chart) => {
      const { ctx } = chart
      const _fill = ctx.fill

      ctx.fill = function () {
        ctx.save()
        ctx.shadowColor = 'rgba(0, 0, 0, 0.1)'
        ctx.shadowBlur = 12
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 3
        _fill.apply(this, arguments)
        ctx.restore()
      }
    },
  }

  // 수직 라인
  const verticalLinePlugin = {
    id: 'verticalLiner',
    afterInit: (chart, args, opts) => {
      chart.verticalLiner = {}
    },
    afterEvent: (chart, args, options) => {
      const { inChartArea } = args
      chart.verticalLiner = { draw: inChartArea }
    },
    beforeTooltipDraw: (chart, args, options) => {
      const { draw } = chart.verticalLiner
      if (!draw) return
      const { ctx } = chart
      const { top, bottom } = chart.chartArea
      const { tooltip } = args
      const x = tooltip?.caretX
      if (!x) return
      ctx.save()
      ctx.beginPath()
      ctx.moveTo(x, top)
      ctx.lineTo(x, bottom)
      ctx.strokeStyle = colors.G2
      ctx.stroke()
      ctx.restore()
    },
  }

  // useEffect(() => {
  //   const chart = chartRef.current

  //   if (chart) {
  //     ChartJS.register({
  //       id: 'verticalLiner',
  //       afterInit: (chart, args, opts) => {
  //         chart.verticalLiner = {}
  //       },
  //       afterEvent: (chart, args, options) => {
  //         const { inChartArea } = args
  //         chart.verticalLiner = { draw: inChartArea }
  //       },
  //       beforeTooltipDraw: (chart, args, options) => {
  //         const { draw } = chart.verticalLiner
  //         if (!draw) return
  //         const { ctx } = chart
  //         const { top, bottom } = chart.chartArea
  //         const { tooltip } = args
  //         const x = tooltip?.caretX
  //         if (!x) return
  //         ctx.save()
  //         ctx.beginPath()
  //         ctx.moveTo(x, top)
  //         ctx.lineTo(x, bottom)
  //         ctx.strokeStyle = colors.G2
  //         ctx.stroke()
  //         ctx.restore()
  //       },
  //     })
  //   }

  //   return () => {
  //     ChartJS.unregister({
  //       id: 'verticalLiner',
  //     })
  //   }
  // }, [])

  useEffect(() => {
    if (chartItem) {
      setData({
        ...data,

        labels: chartItem.period,
        datasets: [
          {
            label: '차트뷰',
            borderColor: colors.mainG,
            borderWidth: 2,
            data: chartItem.count,
            fill: false,
            backgroundColor: 'green',
            pointHoverRadius: 2,
            pointHoverBorderWidth: 4,
          },
        ],
      })

      setOptions({
        responsive: true,

        layout: {
          padding: {
            top: 10,
          },
        },

        elements: {
          point: {
            radius: 0,
          },
        },

        scales: {
          x: {
            grid: {
              display: false,
            },

            ticks: {
              maxTicksLimit: 10,

              font: {
                size: 10,
              },
            },

            offset: true,

            title: {
              display: false,
              text: '날짜',
              font: {
                size: 12,
                weight: 'bold',
              },
            },
            border: {
              display: false,
            },
          },
          y: {
            grid: {
              display: true,
              // color: 'green',
            },

            border: {
              display: false,
            },

            min: 0,
            max: getTicks(Math.max(...chartItem.count)).max,
            // max: Math.ceil((Math.max(...chartItem.count) / 10) * 10),
            // max: Math.max(...chartItem.count) + 20,
            // stepSize: 10,

            ticks: {
              // beginAtZero: false,
              // min: 0,
              // stepSize: 40,
              // stepSize: 10,

              // min: 0,
              // max: Math.max(...chartItem.count) + 20,
              stepSize: getTicks(Math.max(...chartItem.count)).stepSize,

              font: {
                size: 10,
              },
            },
            // position: { x: 0.5 },

            beginAtZero: true,
          },
        },

        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
          },
          title: {
            display: false,
            text: '날짜별 주문 지표',
          },

          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              mode: 'x',
              speed: 100,
            },
            pan: {
              enabled: true,
              mode: 'x',
              speed: 0.5,
            },
          },
          tooltip: {
            backgroundColor: 'white',
            padding: 12,

            titleColor: 'black',
            bodyColor: colors.mainG,
            caretSize: 0,

            titleMarginBottom: 8,

            titleFont: {
              size: 12,
              weight: 400,
            },
            bodyFont: {
              size: 10,
            },
            bodyAlign: 'left',
            footerFont: {},

            usePointStyle: true,

            callbacks: {
              title: function (item) {
                return `${moment().format('YYYY')}.${item[0].label}`
              },
              labelColor: function (item) {
                return {
                  borderColor: 'green',
                  backgroundColor: 'green',
                }
              },
              labelPointStyle: function (context) {
                return {
                  pointStyle: 'circle',
                  rotation: 0,
                }
              },
              label: function (item) {
                return ` ${item.formattedValue}건`
              },
            },
          },
        },

        hover: {
          mode: 'index',
          intersect: false,
        },

        interaction: {
          mode: 'index',
          intersect: false,
        },
      })
    }
  }, [chartItem])

  // console.log('$$ chart data', data)

  return (
    <Container>
      {data && options && (
        <Line
          data={data}
          options={options}
          ref={chartRef}
          plugins={[shadowPlugin, verticalLinePlugin]}
        />
      )}
    </Container>
  )
}

export default NewDateChart

const Container = styled.div`
  width: 100%;
  height: 100%;
  /* min-height: 355px; */
  display: flex;

  @media ${(props) => props.theme.mobile} {
    /* min-height: 198px; */
  }

  /* canvas {
    height: 355px !important;

    @media ${(props) => props.theme.mobile} {
      height: 198px !important;
    }
  } */
`
